<template>
  <section class="panel fading">
    <h1>What can we help you with?</h1>
    <div class="options" :class="type ? 'selected' : ''">
      <a href @click.prevent="type = 'new'" :class="type == 'new' ? 'selected' : ''">
        <span>Creating a new memorial</span>
      </a>
      <a
        href
        @click.prevent="type = 'rennovation'"
        :class="type == 'rennovation' ? 'selected' : ''"
      >
        <span>Rennovating an existing memorial</span>
      </a>
      <a
        href
        @click.prevent="type = 'inscription'"
        :class="type == 'inscription' ? 'selected' : ''"
      >
        <span>Adding an inscription to an existing memorial</span>
      </a>
    </div>

    <div class="actions">
      <button @click="$router.push('you')" class="button back">Back</button>
      <button @click="$router.push(type)" class="button" v-if="type">
        Continue
        <pulse></pulse>
      </button>
    </div>
  </section>
</template>

<script>
import Pulse from "@/components/Pulse.vue"
export default {
  data() {
    return {
      type: ""
    }
  },
  components: {
    Pulse
  }
}
</script>

<style scoped>
.panel {
  text-align: center;
}
.form {
  max-width: 80rem;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4rem;
  margin-top: 5rem;
}
.txt {
  width: 100%;
  border: 1px solid #e7e7e7;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
}
.row {
  margin-bottom: 1rem;
}
.textarea {
  height: 17rem;
}
.options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 5rem;
}
.options.selected a {
  opacity: 0.5;
}
.options a {
  display: flex;
  align-items: center;
  min-height: 20rem;
  text-align: center;
  border: 1px solid #e7e7e7;
  border-radius: 1rem;
  transition: all 0.3s;
  font-size: 2.5rem;
}
.options a:hover {
  opacity: 1;
  background: #fafafa;
}
.options a.selected {
  opacity: 1;
  background: #e3e8e8;
  border: 1px solid #e3e8e8;
}
.options a span {
  display: block;
  width: 100%;
  padding: 5rem;
  line-height: 1.2;
}
@media screen and (max-width: 750px) {
  .form {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  .options {
    grid-template-columns: 1fr;
    grid-gap: 3rem;
  }
  .options a {
    min-height: 5rem;
  }
}
</style>
